module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialogs/periode-dialog/periode-dialog.component.css
// module id = ./src/app/shared/dialogs/periode-dialog/periode-dialog.component.css
// module chunks = main